import { tokenLookup } from '../graphql/authFlowLink';
import { refreshTokenAccessToken } from './refreshTokenAccessToken';
import jwtDecode from 'jwt-decode';

const TOKEN_REFRESH_THRESHOLD = 5 * 60 * 1000; // 5 minutes before expiry
const CHECK_INTERVAL = 60 * 1000; // Check every minute

class TokenManager {
  private checkInterval: NodeJS.Timeout | null = null;
  private isRefreshing = false;

  start() {
    if (this.checkInterval) {
      return;
    }

    this.checkInterval = setInterval(async () => {
      await this.checkAndRefreshToken();
    }, CHECK_INTERVAL);

    // Initial check
    this.checkAndRefreshToken();
  }

  stop() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  private async checkAndRefreshToken() {
    if (this.isRefreshing) {
      return;
    }

    try {
      const authHeader = await tokenLookup();
      if (!authHeader.authorization) {
        return;
      }

      // Parse JWT to get expiration
      const payload = jwtDecode<{ exp: number }>(authHeader.authorization);
      const exp = payload.exp * 1000; // Convert to milliseconds
      const now = Date.now();
      const timeUntilExpiry = exp - now;

      if (timeUntilExpiry <= TOKEN_REFRESH_THRESHOLD) {
        console.log('Token Manager: Token expiring soon, refreshing...', {
          deviceId: authHeader.device,
          storeId: authHeader.store,
          timeUntilExpiry: Math.round(timeUntilExpiry / 1000),
        });

        this.isRefreshing = true;
        await refreshTokenAccessToken();

        console.log('Token Manager: Token refreshed successfully', {
          deviceId: authHeader.device,
          storeId: authHeader.store,
          timestamp: new Date().toISOString(),
        });
      }
    } catch (error) {
      console.error('Token Manager: Error checking/refreshing token:', {
        error: error,
        timestamp: new Date().toISOString(),
      });
    } finally {
      this.isRefreshing = false;
    }
  }
}

export const tokenManager = new TokenManager();
